import React, { useState } from 'react';
import {
	MessageAttachment,
	MessageAttachmentType,
} from '../../../../graphql/graphql';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import QuestionnairePreviewModal from '../../../Questionnaire/Components/QuestionnairePreview/QuestionnairePreviewModal';
import useTranslation from '../../../../Hooks/useTranslation';
import { Size } from '../../../../Enums/Size.enum';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import { v4 } from 'uuid';
import EducationMaterialViewer from '../../../EducationMaterial/Components/EducationMaterialViewer/EducationMaterialViewer';

interface Props {
	item: MessageAttachment;
}

const ActionCenterConversationMessageAttachment: React.FC<Props> = ({
	item,
}) => {
	const { t } = useTranslation();
	const [isAttachmentOpen, setIsAttachmentOpen] = useState(false);

	switch (item.type) {
		case MessageAttachmentType.Questionnaire:
			if (!item?.questionnaire?.id) {
				return <></>;
			}
			return (
				<>
					<LinkButton
						theme={Theme.BLUE}
						title={`${t('base.shared.questionnaire')} - ${
							item?.questionnaire?.title
						}`}
						onClick={() => setIsAttachmentOpen(true)}
					/>
					{isAttachmentOpen && (
						<QuestionnairePreviewModal
							isOpen
							onClose={() => setIsAttachmentOpen(false)}
							questionnaireId={item.questionnaire.id}
							size={Size.XL}
						/>
					)}
				</>
			);
		case MessageAttachmentType.EducationMaterial:
			return (
				<>
					<LinkButton
						theme={Theme.BLUE}
						title={`${t('base.educationMaterial')} - ${
							item?.educationMaterial?.name
						}`}
						onClick={() => setIsAttachmentOpen(true)}
					/>
					{isAttachmentOpen && item?.educationMaterial && (
						<EducationMaterialViewer
							isOpen
							onClose={() => setIsAttachmentOpen(false)}
							educationMaterial={item.educationMaterial}
						/>
					)}
				</>
			);
		default:
			return <></>;
	}
};

export default ActionCenterConversationMessageAttachment;
